import { Sprout, LogIn, AlertTriangle } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const [lastError, setLastError] = useState("");

  useEffect(() => {
    try {
      const msg = sessionStorage.getItem("rmj_last_signin_error");
      if (msg) setLastError(msg);
    } catch (e) { /* ignore */ }
  }, []);

  const handleGoogleSignIn = () => {
    try { sessionStorage.removeItem("rmj_last_signin_error"); } catch (e) { /* ignore */ }
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div
      className="App grain min-h-screen flex items-center justify-center px-4"
      data-testid="login-page"
    >
      <div className="w-full max-w-md bg-white/90 backdrop-blur-sm border border-[#d6cdb4] rounded-2xl shadow-xl p-8">
        <div className="flex flex-col items-center text-center">
          <div className="bg-white rounded-xl p-2 shadow-md mb-4 border border-[#e7dfc5]">
            <img
              src="/brand/ramajeyam-logo.jpg"
              alt="Ramajeyam Rice"
              className="h-28 w-28 object-contain"
              data-testid="login-logo"
            />
          </div>
          <h1 className="brand-serif text-3xl font-bold text-[#1d3a14] leading-tight">
            Ramajeyam Rice
          </h1>
          <p className="text-xs tracking-widest uppercase text-[#5b6b4a] mt-1">
            RMJ Sales Order System
          </p>
          <p className="mt-6 text-[#264a1a] text-sm max-w-sm italic">
            Happiness is Natural · Since 1988
          </p>
          <p className="mt-3 text-[#5b6b4a] text-sm max-w-sm">
            Sign in with your authorised Google account to create or manage
            sale orders.
          </p>
          <Button
            onClick={handleGoogleSignIn}
            data-testid="google-signin-button"
            className="mt-6 w-full bg-[#1d3a14] hover:bg-[#264a1a] text-[#faf6ea] h-11 text-base"
          >
            <LogIn className="h-5 w-5 mr-2" />
            Sign in with Google
          </Button>
          {lastError && (
            <div
              data-testid="last-signin-error"
              className="mt-4 w-full text-left bg-[#fdecec] border border-[#e8b4b4] rounded-lg p-3 flex gap-2"
            >
              <AlertTriangle className="h-4 w-4 text-[#a04040] shrink-0 mt-0.5" />
              <div className="text-xs text-[#a04040] break-words">
                <span className="font-semibold">Last sign-in error:</span>
                <span className="ml-1 font-mono">{lastError}</span>
              </div>
            </div>
          )}
          <div className="flex items-center gap-2 mt-6 text-[11px] text-[#5b6b4a]">
            <Sprout className="h-3 w-3" />
            <span className="tracking-wider uppercase">
              Freshly Milled · Daily Dispatch
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
